import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import './dashbordPage.css';
import { useAuth } from '../context/AuthContext'; // ✅ Import useAuth correctly
import { permissions } from "./permissions"; // ✅ Import permissions
import axios from 'axios';
import { API_URL } from './environment';
import { collectLoginClientInfo } from "../helpers/browser-info";

// Import icons
import homeIcon from '../images/icons/home-icon.svg';
import createIcon from '../images/icons/create-icon.svg';
import validateIcon from '../images/icons/validate-icon.svg';
import historyIcon from '../images/icons/history-icon.svg';
import shiftIcon from '../images/reprint.svg';
// import shiftIcon from '../images/icons/shift-icon.svg';

function Dashbord() {
    const navigate = useNavigate();
    const [topButtonsShow, setTopButtonsShow] = useState(true);
    const { user, login, logout } = useAuth(); // ✅ Now user, login, and logout are accessible
    const [shopName, setShopName] = useState('');

    useEffect(() => {
        const fetchShiftData = async () => {
          const storedUserRaw = localStorage.getItem("sun_user");
          let storedUser;

          try {
            storedUser = JSON.parse(storedUserRaw);
          } catch (e) {
            storedUser = {};
          }

          const agentID = localStorage.getItem("sun_userId") || '';
          const bettingShopID = localStorage.getItem('sun_bettingShopId') || '';
          // load betting shop name
          if (agentID && bettingShopID) {
            try {
                const checkShiftRes = await axios.post(`${API_URL}/checkactiveshift`, {
                  bettingShopId: bettingShopID,
                  agentId: agentID,
                });

                const hasActiveShift = checkShiftRes?.data?.hasActiveShift;
                const isPendingShift = checkShiftRes?.data?.shiftStatus === 'PENDING';
                if (storedUser?.role === 'CASHIER' && (!hasActiveShift || isPendingShift)) {
                  setTopButtonsShow(false);
                }
                if (storedUser?.role === 'CASHIER') {
                    const shopRes = await axios.get(`${API_URL}/bettingshopbyid`, {
                        params: {_id: bettingShopID},
                    });
                    const shopName = shopRes?.data?.[0]?.name || '';
                    setShopName(shopName);
                    setIsMenuOpen(true);
                }
              } catch (err) {
                console.error('Failed to check active shift:', err);
              }    
          }
        };
      
        fetchShiftData();
        document.body.classList.add('dashbord-active');
        return () => {
          document.body.classList.remove('dashbord-active');
        };
      }, []);

    // ✅ Function to check access
    const hasAccess = (path) => user && permissions[user.role]?.includes(path);

    const runLogout = async() => {
        const userId = localStorage.getItem("sun_userId");
        // track action
        try {
          // await axios.post(`${API_URL}/logout`, {
          //     user: userId,
          // });

          const bettingShopId = localStorage.getItem('sun_bettingShopId');
          // GET ip address
          const IP_SERVICE = 'https://api64.ipify.org/?format=json';
          const ipRes = await axios.get(IP_SERVICE);
          // console.log('ipRes', ipRes);
          const curIp = (ipRes && ipRes.data && ipRes.data.ip) || 0;

          const metadata = await collectLoginClientInfo({
            includeGeolocation: true,
            geolocationOptions: {
              enableHighAccuracy: false,
              timeout: 2000,
              maximumAge: 300000,
            },
          });

          await axios.post(`${API_URL}/logaction`, {
            action: 'logout_user',
            role: user.role,
            user: userId,
            bettingShopId,
            ipAddress: curIp,
            metadata,
          });

          logout();

          navigate('/login');

        } catch (e) {
            console.error(e);
        }
    }

    const [isMenuOpen, setIsMenuOpen] = useState(false);

    const toggleMenu = () => {
        setIsMenuOpen(!isMenuOpen);
    };

    return (
        <>
        <div className="dashbord-wr"> 
        
            {/* Role Selection Buttons Debug */}

            <div className={`admin-page-menu ${isMenuOpen ? 'menu-open' : 'menu-closed'}`}>
          {/* Toggle button */}
          {/* <div className="admin-page-menu__toggle" onClick={toggleMenu}>
            <div className="admin-page-menu__toggle-icon">
              <img src={isMenuOpen ? iconClose : iconOk} alt={isMenuOpen ? "Close" : "Open"} />
            </div>
          </div> */}
          
          {/* Menu items - only show when menu is open */}
          {isMenuOpen && (
            <>
              <div className="admin-page-menu__item" onClick={() => navigate('/dashboard')}>
                <div className="admin-page-menu__item-icon">
                  <img src={homeIcon} alt="Home" />
                </div>
                <div className="admin-page-menu__item-title">
                  <span>HOME</span>
                </div>
              </div>
              <div className={`admin-page-menu__item ${topButtonsShow?'':'gray-out'}`} onClick={() => navigate('/admin')}>
                <div className="admin-page-menu__item-icon">
                  <img src={createIcon} alt="Create" />
                </div>
                <div className="admin-page-menu__item-title">
                  <span>CREATE</span>
                </div>
              </div>
              <div className={`admin-page-menu__item ${topButtonsShow?'':'gray-out'}`} onClick={() => navigate('/validate')}>
                <div className="admin-page-menu__item-icon">
                  <img src={validateIcon} alt="Validate" />
                </div>
                <div className="admin-page-menu__item-title">
                  <span>VALIDATE</span>
                </div>
              </div>
            <div className={`admin-page-menu__item ${topButtonsShow?'':'gray-out'}`} onClick={() => navigate('/tickethistory')}>
                <div className="admin-page-menu__item-icon">
                  <img src={historyIcon} alt="History" />
                </div>
                <div className="admin-page-menu__item-title">
                  <span>HISTORY</span>
                </div>
              </div>
              <div className="admin-page-menu__item" onClick={() => navigate('/shift-management')}>
                <div className="admin-page-menu__item-icon">
                  <img src={shiftIcon} alt="Shift" />
                </div>
                <div className="admin-page-menu__item-title">
                  <span>SHIFT</span>
                </div>
              </div>
            </>
          )}
        </div>

        <div className="dashboard-content"> 

            <div className="dashbord__wrap">
                <div className="spin-border dashbord-border">
                    <div className="spin-light spin-light-top">
                        <div className="spin-light-container">
                            {Array.from({ length: 15 }).map((_, index) => (
                                <div className="spin-light-item" style={{ animationDelay: `${index * 0.2}s` }} key={index}></div>
                            ))}
                        </div>
                    </div>
                    <div className="spin-number">
                        <div className="spin-number__text">
                            <span className="spin-number__text-big">MAIN MENU</span>
                        </div>
                    </div>
                    <div className="spin-light spin-light-bottom">
                        <div className="spin-light-container">
                            {Array.from({ length: 15 }).map((_, index) => (
                                <div className="spin-light-item" style={{ animationDelay: `${index * 0.2}s` }} key={index}></div>
                            ))}
                        </div>
                    </div>
                </div>

                <div className="shop-name">
                    {shopName}
                </div>

                <div className="role-buttons">
                    {/* <button onClick={() => login("ADMIN")}>Login as Admin</button>
                    <button onClick={() => login("AGENT")}>Login as Agent</button>
                    <button onClick={() => login("CASHIER")}>Login as Cashier</button> */}
                    <button onClick={()=> { runLogout(); }}>Logout</button>
                </div>
            </div>
            

            {/* Buttons based on user permissions */}
            {/* dashbord-top__btn--disabled */}
            <div className="dashbord-top">
                {hasAccess("/createticket") && <button className={`dashbord-top__btn ${topButtonsShow?'':'gray-out'}`} onClick={() => navigate("/admin")}>CREATE TICKET</button>}
                {hasAccess("/validate") && <button className={`dashbord-top__btn ${topButtonsShow?'':'gray-out'}`} onClick={() => navigate("/validate")}>VALIDATE TICKET</button>}
                {hasAccess("/tickethistory") && <button className={`dashbord-top__btn ${topButtonsShow?'':'gray-out'}`} onClick={() => navigate("/tickethistory")}>TICKET HISTORY</button>}
            </div>

            <div className="dashbord-middle">
                {hasAccess("/shift-management") && <button className="dashbord-middle__btn" onClick={() => navigate("/shift-management")}>SHIFT MANAGEMENT</button>}
                {hasAccess("/betting-shop") && <button className="dashbord-middle__btn" onClick={() => navigate("/betting-shop")}>BETTING SHOP MANAGEMENT</button>}
                {hasAccess("/user-management") && <button className="dashbord-middle__btn" onClick={() => navigate("/user-management")}>USER MANAGEMENT</button>}
                {hasAccess("/profitshare-report") && <button className="dashbord-middle__btn" onClick={() => navigate("/profitshare-report")}>PROFIT SHARE</button>}
            </div>

            <div className="dashbord-bottom">
                {hasAccess("/shift-history") && <button className="dashbord-bottom__btn" onClick={() => navigate("/shift-history")}>SHIFT HISTORY</button>}
                {hasAccess("/shift-review") && <button className="dashbord-bottom__btn" onClick={() => navigate("/shift-review")}>SHIFT REVIEW</button>}
                {hasAccess("/reports") && <button className="dashbord-bottom__btn" onClick={() => navigate("/reports")}>WIN / LOSS</button>}
            </div>
            </div>
            </div>
        </>
    );
}

export default Dashbord;
